class Address{
    constructor(value, label){
        this.value = value;
        this.label = label;
       }
}

export default Address;